import { makeBetterEnum } from './betterEnum';

export const FinanceAuditAction = makeBetterEnum(
  'BulkImport',
  'SidebarUpdate',
  'CreateAssetDialog',
  'APIRequest',
  'AssetPageUpdate',
  'EstimateEmissions',
  'CompanyMatchUpdate',
  'EngagementTask',
  'BulkUpdateAssetFromFlags',
  'WatershedUpdate'
);

export type FinanceAuditAction =
  (typeof FinanceAuditAction)[keyof typeof FinanceAuditAction];

export const FinanceMetric = makeBetterEnum(
  'AssetCount',
  'EconomicIntensity',
  'EconomicIntensityScope1And2',
  'FinancedEmissions',
  'FinancedEmissionsScope1',
  'FinancedEmissionsScope1And2',
  'FinancedEmissionsScope2',
  'FinancedEmissionsScope3',
  'HoldingCount',
  'Pcaf',
  'PcafScope1',
  'PcafScope2',
  'PcafScope3',
  'RevenueIntensity',
  'RevenueIntensityScope1',
  'RevenueIntensityScope2',
  'RevenueIntensityScope3',
  'TotalEmissions',
  'TotalEmissionsScope1',
  'TotalEmissionsScope2',
  'TotalEmissionsScope3',
  'TotalOutstandingAmount',
  'Waci',
  'WaciScope1',
  'WaciScope2',
  'WaciScope3',
  'IciAlignment'
);

export type FinanceMetric = (typeof FinanceMetric)[keyof typeof FinanceMetric];

export const FinanceTagType = makeBetterEnum(
  'AssetTag',
  'AssetYearTag',
  'FundTag',
  'HoldingTag'
);

export type FinanceTagType =
  (typeof FinanceTagType)[keyof typeof FinanceTagType];

export const FundAssetClass = makeBetterEnum(
  'ListedEquity',
  'CorporateBonds',
  'UnlistedEquity',
  'BusinessLoans',
  'CommercialRealEstate',
  'Mortgages',
  'ProjectFinance',
  'AssetGroup',
  'SovereignDebt',
  'PersonalMotorVehicleInsurance',
  'CommercialLineOfInsurance'
);

export type FundAssetClass =
  (typeof FundAssetClass)[keyof typeof FundAssetClass];

export const FinanceReminderType = makeBetterEnum(
  'MeasurementProject',
  'FootprintFinalization'
);

export type FinanceReminderType =
  (typeof FinanceReminderType)[keyof typeof FinanceReminderType];

export const FinanceStandardView = makeBetterEnum(
  'Overview',
  'FundCategory',
  'FundGroup',
  'Fund',
  'Asset',
  'YearOverYear'
);

export type FinanceStandardView =
  (typeof FinanceStandardView)[keyof typeof FinanceStandardView];

export const VehiclePowertrain = makeBetterEnum(
  'CombustionGasoline',
  'CombustionDiesel',
  'HybridGasoline',
  'HybridDiesel',
  'PlugInHybridGasoline',
  'BatteryElectric'
);

export type VehiclePowertrain =
  (typeof VehiclePowertrain)[keyof typeof VehiclePowertrain];

export const VehicleCategory = makeBetterEnum(
  'Car',
  'Motorcycle',
  'VanLightTruck',
  'MediumHeavyTruck'
);

export type VehicleCategory =
  (typeof VehicleCategory)[keyof typeof VehicleCategory];

export const FuelEfficiencyUnit = makeBetterEnum(
  'MilesPerGallon',
  'KmPerLiter'
);

export type FuelEfficiencyUnit =
  (typeof FuelEfficiencyUnit)[keyof typeof FuelEfficiencyUnit];

export const ElectricityEfficiencyUnit = makeBetterEnum(
  'MilesPerKilowattHour',
  'KilometersPerKilowattHour'
);

export type ElectricityEfficiencyUnit =
  (typeof ElectricityEfficiencyUnit)[keyof typeof ElectricityEfficiencyUnit];

export const DistanceUnit = makeBetterEnum('Kilometers', 'Miles');

export type DistanceUnit = (typeof DistanceUnit)[keyof typeof DistanceUnit];

export const EstimationMethodology = makeBetterEnum(
  'CEDA',
  'USEEIO',
  'CEDA_V5',
  'CEDA_V7',
  'USEEIO_2_1',
  'USEEIO_2_2_22'
);

export type EstimationMethodology =
  (typeof EstimationMethodology)[keyof typeof EstimationMethodology];

export const IciAlignmentStatus = makeBetterEnum(
  'NotStarted',
  'CapturingData',
  'PreparingToDecarbonize',
  'Aligning',
  'Aligned'
);

export type IciAlignmentStatus =
  (typeof IciAlignmentStatus)[keyof typeof IciAlignmentStatus];

export const CompanySBTCommitmentStage = makeBetterEnum(
  // The company has not committed to SBT.
  'None',
  // The company has committed to SBT.
  'Committed',
  // Company has made science-aligned targets
  'TargetsDeveloped',
  // Company has submitted targets to SBT
  'TargetsSubmitted',
  // The company has committed to SBT and set targets.
  // TODO: Rename this to TargetsValidated
  'TargetsSet',
  // The company has removed its SBT commitment.
  'Removed'
);

export type CompanySBTCommitmentStage =
  (typeof CompanySBTCommitmentStage)[keyof typeof CompanySBTCommitmentStage];
